/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { Avatar, List, ListItem, Typography } from '@mui/material';
import { convertFormatPhone } from '../../../../../../utils/convertFormatPhone.utils';
import { getUserFiltred } from '../../../../../../store/reducers/user/userAction';
import { IMAGES } from '../../../../../../config/assets';


const AdminUserInfo = ({ userid }) => {
    const userById = useSelector(state => state.user.userInfo)
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(getUserFiltred({ offset: 0, limit: 1, skip: 0, where: { userid } }));
    }, [dispatch, userid]);

    return (
        < >
            {userById && userById.length > 0 ? <>

                <List>
                    <ListItem style={{ marginBottom: '20px' }}>
                        <Avatar
                            style={{ width: '45px', height: '45px', marginRight: '10px' }}
                            src={
                                userById.useravatar
                                    ? userById.useravatar
                                    : IMAGES.AVATAR_DEFAULT
                            }
                        ></Avatar>  <Typography variant='h2' color="primary">{userById[0].username} user information</Typography>
                    </ListItem>
                    <ListItem>
                        <Typography variant='h3'>Username : {userById[0].username}</Typography>
                    </ListItem>
                    <ListItem>
                        <Typography variant='h3'>Full Name : {userById[0].firstname} {userById.lastname}</Typography>
                    </ListItem>
                    <ListItem>
                        <Typography variant='h3'>E-mail : {userById[0].email ? userById[0].email : ' N/A'}</Typography>
                    </ListItem>
                    <ListItem>
                        <Typography variant='h3'>Cellphone :{userById[0].cellphone ? convertFormatPhone.getFormattedPhoneNum(userById[0].cellphone) : ' N/A'}</Typography>
                    </ListItem>
                </List>
            </> : <Typography variant='h3' align='center'> No user information available now, please try later.</Typography>}
        </ >
    )

}

export default AdminUserInfo;
